import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function termsAndConditions() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            active: true
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`term-conditions/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`term-conditions/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('term-conditions/create', data);
    }

    function update(data) {
        return axiosInstance.patch('term-conditions/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`term-conditions/delete`, {
            data: {
                id: id
            }
        });
    }
}
